module.exports = __webpack_public_path__ + "media/site_templates/www.localcleaners.net.au/images/feature_1-1bb1ce900d10711b63674f6d54f41f9c.jpeg";